import React from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, useLocation } from 'react-router-dom'


export default function Sidebar() {
  // const location = useLocation();

  const location = useLocation();
  const { t } = useTranslation();
  // console.log(location);

  return (
    <div className='sidebar'>
      <div className='sidebar-menu'>
        <ul>

          <li>
            <NavLink end to={'/restaurant/sales'} className={location.pathname.endsWith('sales') || location.pathname.endsWith('month') || location.pathname.endsWith('week') ? 'active' : ''}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 2V19C2 20.66 3.34 22 5 22H22" stroke="#1A1A1A" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 17L9.59 11.64C10.35 10.76 11.7 10.7 12.52 11.53L13.47 12.48C14.29 13.3 15.64 13.25 16.4 12.37L21 7" stroke="#1A1A1A" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
              </svg>

              <span>{t('restaurant.sales.label_revenue_analysis')}</span>
            </NavLink>
          </li>

          <li>
            <NavLink end to={'/restaurant/sales/order/1'} className={location.pathname.includes('sales/order') ? 'active' : ''}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.32 12C20.92 12 22 11 21.04 7.72C20.39 5.51 18.49 3.61 16.28 2.96C13 2 12 3.08 12 5.68V8.56C12 11 13 12 15 12H18.32Z" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20.0001 14.7C19.0701 19.33 14.6301 22.69 9.58005 21.87C5.79005 21.26 2.74005 18.21 2.12005 14.42C1.31005 9.39001 4.65005 4.95001 9.26005 4.01001" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>

              <span>{t('restaurant.sales.label_order_history')}</span>

            </NavLink>
          </li>

          <li>
            <NavLink end to={`/restaurant/sales/sales-transaction-history/${1}`} className={location.pathname.includes('sales-transaction-history') || location.pathname.includes('sales-slip-changes') ? 'active' : ''}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z" stroke="#171717" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5" stroke="#171717" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 13H12" stroke="#171717" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 17H16" stroke="#171717" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
              </svg>

              <span>{t('restaurant.sales.label_transaction_history')}</span>
            </NavLink>
          </li>


        </ul>
      </div>
    </div>
  )
}


